import Vue from 'vue';
import _ from 'lodash';

const state = {
	queries: {
		// _users: {
		// 	order: null,
		// 	filter: null,
		// 	search: '',
		// 	limit: 10,
		// }
	}
};

const getters = {
	'queries/get': function (st) {
		return (view) => {
			if (typeof st.queries[view] !== 'undefined') return st.queries[view];
			return false;
		};
	},
	'queries/filter/search': function (state) {
		return ({ view, type = null, field, value = null, lig = null, from = null, to = null }) => {
			try {
				const filter = state.queries[view] ? state.queries[view].filter : null;

				if (view && field && filter) {
					const results = [];
					for (let i = 0; i < filter.length; i += 1) {
						if (filter[i].Fields[field] !== undefined
							&& (filter[i].Fields[field].type === type || type === null)
							&& (filter[i].Fields[field].value === value || value === null)
							&& (filter[i].Fields[field].lig === lig || lig === null)
							&& (filter[i].Fields[field].from === from || from === null)
							&& (filter[i].Fields[field].to === to || to === null)
						) {
							results.push(filter[i].Fields[field]);
						}
					}

					if (results.length > 0) return results;
				}

				return false;
			} catch (error) {
				console.error(error);
				return false;
			}
		};
	}
};

const mutations = {
	'QUERIES/CLEAN': function (st) {
		st.queries = {};
	},
	'QUERIES/INIT': function (st, view) {
		Vue.set(st.queries, view, {
			search: '',
			filter: null,
			limit: 10,
			order: null
		});
	},
	'QUERIES/SET': function (st, { view, params }) {
		if (st.queries[view] === undefined) {
			Vue.set(st.queries, view, {
				search: '',
				filter: null,
				limit: 10,
				order: null
			});
		}

		if (params.search !== undefined) Vue.set(st.queries[view], 'search', params.search);
		if (params.filter !== undefined) Vue.set(st.queries[view], 'filter', params.filter);
		if (params.limit !== undefined) Vue.set(st.queries[view], 'limit', params.limit);
		if (params.order !== undefined) Vue.set(st.queries[view], 'order', params.order);
	}
};

const actions = {
	'queries/clean': function ({ commit }) {
		commit('QUERIES/CLEAN');
	},
	'queries/set': function ({ commit, state }, { view, params }) {
		if (state.queries[view] === undefined) commit('QUERIES/INIT', view);

		commit('QUERIES/SET', { view, params });
	},
	'queries/reset': function ({ commit }, view) {
		commit('QUERIES/SET', { view });
	},
	'queries/filter/add': function ({ commit, getters, state }, { view, type, field, value, lig = null, from = null, to = null }) {
		try {
			if (view && type && field) {
				if (type === 'text' || type === 'number' || type === 'select' || type === 'date' || type === 'relation') {
					if (state.queries[view] === undefined) commit('QUERIES/INIT', view);
					let filter = _.cloneDeep(state.queries[view].filter);

					if (type === 'date' && from === null && to === null) {
						throw new Error(`El filtro fecha definido para la vista ${view} no esta definido`);
					}

					if (lig) {
						if (lig !== '>' && lig !== '>=' && lig !== '=' && lig !== '<' && lig !== '<=' && lig !== '%') {
							throw new Error(`El operador ${lig} no es correcto. Debe ser: (>,>=,=,<,<=,%)`);
						}
					} else if (type !== 'date' && lig === null) {
						lig = '=';
					}

					if (filter === null) {
						filter = [{
							_ParentOperator: 'OR',
							_Operator: 'OR',
							Fields: {
								[field]: {
									type,
									lig,
									value,
									from,
									to
								}
							}
						}];

						commit('QUERIES/SET', { view, params: { filter } });
						return state.queries[view].filter;
					}

					let exists = false;
					for (let i = 0; i < filter.length; i += 1) {
						if (type === 'date') {
							if (filter[i].Fields[field] !== undefined
								&& filter[i].Fields[field].type === type
								&& filter[i].Fields[field].from === from
								&& filter[i].Fields[field].to === to
							) {
								exists = true;

								filter[i].Fields[field] = {
									type,
									lig,
									value,
									from,
									to
								};

								commit('QUERIES/SET', { view, params: { filter } });
								return getters['queries/get'](view).filter;
							}
						} else if (filter[i].Fields[field] !== undefined
							&& filter[i].Fields[field].type === type
							&& filter[i].Fields[field].value === value
							&& filter[i].Fields[field].lig === lig
						) {
							exists = true;

							filter[i].Fields[field] = {
								type,
								lig,
								value,
								from,
								to
							};

							commit('QUERIES/SET', { view, params: { filter } });
							return getters['queries/get'](view).filter;
						}
					}

					if (!exists) {
						filter.push({
							_ParentOperator: 'OR',
							_Operator: 'OR',
							Fields: {
								[field]: {
									type,
									lig,
									value,
									from,
									to
								}
							}
						});

						commit('QUERIES/SET', { view, params: { filter } });
						return getters['queries/get'](view).filter;
					}
				}
			}

			return false;
		} catch (error) {
			console.error(error);
			return false;
		}
	},
	'queries/filter/delete': function ({ commit, state }, { view, type = null, field = null, value = null, lig = null, from = null, to = null }) {
		try {
			if (view) {
				if (state.queries[view] === undefined) commit('QUERIES/INIT', view);
				let filter = _.cloneDeep(state.queries[view].filter);

				if (filter === null) return false;

				let exists = false;
				for (let i = 0; i < filter.length; i += 1) {
					if (field) {
						if (filter[i].Fields[field] !== undefined
							&& (filter[i].Fields[field].type === type || type === null)
							&& (filter[i].Fields[field].value === value || value === null)
							&& (filter[i].Fields[field].lig === lig || lig === null)
							&& (filter[i].Fields[field].from === from || from === null)
							&& (filter[i].Fields[field].to === to || to === null)
						) {
							exists = true;
							delete filter[i].Fields[field];
						}
					} else {
						for (let u = 0; u < Object.keys(filter[i].Fields).length; u += 1) {
							const key = Object.keys(filter[i].Fields)[u];

							if ((filter[i].Fields[key] !== undefined || field === null)
								&& (filter[i].Fields[key].type === type || type === null)
								&& (filter[i].Fields[key].value === value || value === null)
								&& (filter[i].Fields[key].lig === lig || lig === null)
								&& (filter[i].Fields[key].from === from || from === null)
								&& (filter[i].Fields[key].to === to || to === null)
							) {
								exists = true;
								delete filter[i].Fields[key];
							}
						}
					}
				}

				filter = filter.filter((f) => Object.keys(f.Fields).length > 0);

				if (filter.length <= 0) filter = null;

				if (exists) {
					commit('QUERIES/SET', { view, params: { filter } });
					return true;
				}
			}

			return false;
		} catch (error) {
			console.error(error);
			return false;
		}
	},
	'queries/filter/search': function ({ commit, state }, { view, type = null, field, value = null, lig = null, from = null, to = null }) {
		try {
			if (view && field) {
				if (state.queries[view] === undefined) commit('QUERIES/INIT', view);
				const filter = state.queries[view].filter;

				if (filter) {
					const results = [];
					for (let i = 0; i < filter.length; i += 1) {
						if (filter[i].Fields[field] !== undefined
						&& (filter[i].Fields[field].type === type || type === null)
						&& (filter[i].Fields[field].value === value || value === null)
						&& (filter[i].Fields[field].lig === lig || lig === null)
						&& (filter[i].Fields[field].from === from || from === null)
						&& (filter[i].Fields[field].to === to || to === null)
						) {
							results.push(filter[i].Fields[field]);
						}
					}

					if (results.length > 0) return results;
				}
			}

			return false;
		} catch (error) {
			console.error(error);
			return false;
		}
	},
	'queries/filter/reset': function ({ state, commit }, view) {
		if (state.queries[view] === undefined) {
			commit('QUERIES/INIT', view);
		} else {
			commit('QUERIES/SET', { view, params: { filter: null } });
		}

		return true;
	},
	'queries/order/add': function ({ commit, state }, { view, field, value = null }) {
		if (view && field) {
			if (state.queries[view] === undefined) commit('QUERIES/INIT', view);
			let order = _.cloneDeep(state.queries[view].order);

			if (order === null) order = {};

			if (order[field] === undefined) {
				if (value === null) {
					order[field] = 'desc';
				} else {
					order[field] = value;
				}
			} else {
				const dir = order[field];

				if (value === null) {
					if (dir === 'desc') {
						order[field] = 'asc';
					} else {
						order[field] = 'desc';
					}
				} else {
					order[field] = value;
				}
			}

			commit('QUERIES/SET', { view, params: { order } });
			return getters['queries/get'](view).order;
		}

		return false;
	},
	'queries/order/delete': function ({ commit, state }, { view, field }) {
		if (view && field) {
			if (state.queries[view] === undefined) commit('QUERIES/INIT', view);
			let order = _.cloneDeep(state.queries[view].order);

			if (order[field] !== undefined) {
				delete order[field];

				if (Object.keys(order).length === 0) order = null;
				commit('QUERIES/SET', { view, params: { order } });
				return true;
			}
		}

		return false;
	},
	'queries/order/reset': function ({ state, commit }, view) {
		if (state.queries[view] === undefined) {
			commit('QUERIES/INIT', view);
		} else {
			commit('QUERIES/SET', { view, params: { order: null } });
		}

		return true;
	},
	'queries/search': function ({ state, commit, dispatch }, { view, value = '' }) {
		try {
			if (view) {
				if (state.queries[view] === undefined) commit('QUERIES/INIT', view);

				dispatch('queries/filter/delete', {
					view,
					type: 'text',
					lig: '%'
				});

				if (value) {
					const app = Vue.prototype.$gestios.$cache.view(view).app;
					const fields = Vue.prototype.$gestios.$cache.app(app).data().Fields;

					for (let i = 0; i < Object.keys(fields).length; i += 1) {
						const key = Object.keys(fields)[i];

						if (fields[key].Searchable) {
							dispatch('queries/filter/add', {
								view,
								value,
								lig: '%',
								type: 'text',
								field: key
							});
						}
					}
				}

				commit('QUERIES/SET', { view, params: { search: value } });

				return true;
			}
			return false;
		} catch (error) {
			console.error(error);
			return false;
		}
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
